import { Grid, Button } from '@material-ui/core';
import { Alert, Stack } from '@mui/material';
import { useHistory } from 'react-router';
import colores from '../../shared/constants/styles';
import IconStatus from "../../shared/iconStatus";
import rutas from "../../routes/constants/routes";

const Cliente = (props) => {

    const history = useHistory();
    const {data} = props;
    
    const statusActive = {
        name: "Activo",
        color: colores.activo
    }
    const statusInactive = {
        name: "Inactivo",
        color: colores.inactivo
    }

    return (
        <Grid className="bordesRedondos cliente" item xs={12} sm={6} md={4} lg={4} wrap="nowrap">
            <Grid className="bordesRedondosTop white-color p-4 text-uppercase" style={{backgroundColor: colores.azulOscuro}}>
                <Grid container>
                    <Grid item xs={10}>
                        <h3>{`${data?.razonSocial ? data?.razonSocial : "-"}`}</h3>
                    </Grid>
                    <Grid item xs={2}>
                        <IconStatus config={data?.visible == 'True' ? statusActive : statusInactive}/>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12} style={{backgroundColor: colores.grisClaro}} className="bordesRedondosBottom p-4">
                <Grid item className="atributoTitle">Id Totvs</Grid>
                <Grid item className="atributoDato" style={{marginBottom: "1vh"}}>{data?.id ? data?.id : "-"}</Grid>
                <Grid item className="atributoTitle">Nro. de documento</Grid>
                <Grid item className="atributoDato" style={{marginBottom: "1vh"}}>{data?.documentoNro ? data?.documentoNro : "-"}</Grid>
                <Grid item className="atributoTitle">Razón Social</Grid>
                <Grid item className="atributoDato" style={{marginBottom: "1vh"}}>{data?.razonSocial ? data?.razonSocial : "-"}</Grid>
                <Grid item className="atributoTitle">Vendedor</Grid>
                <Grid item className="atributoDato" style={{marginBottom: "1vh"}}>{data?.apellidoNombre ? data?.apellidoNombre : "-"}</Grid>
                <Grid item className="atributoTitle">Lista de precio</Grid>
                <Grid item className="atributoDato">{data?.listaPrecioId ? data?.listaPrecioId : "-"}</Grid>
                {
                    data?.documentoNro ?
                        <Button 
                            className="my-3"
                            style={{backgroundColor: colores.rojo, color: '#fff'}}
                            variant="contained"
                            onClick = { (e) => history.push(`${rutas.PERFILCLIENTEVENDEDOR}/${data?.id}`) }
                        > 
                            Ver Perfil 
                        </Button>:
                        <Stack sx={{ width: '100%' }} spacing={2}>
                            <Alert severity="warning">El cliente no esta sincronizado</Alert>
                        </Stack>
                }
                
            </Grid> 
            
        </Grid>
    )

}
export default Cliente